import { useEffect, useState } from 'react';
import { getThumbnailBlob } from '../storage/projectRepository';

export function useProjectThumbnailUrl(
  projectId: string,
  thumbnailAssetId?: string,
): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;

    if (!thumbnailAssetId) {
      // Defer to a microtask so this reset happens in a callback rather than
      // synchronously in the effect body (avoids cascading renders).
      Promise.resolve().then(() => {
        if (!cancelled) setUrl(null);
      });
      return () => {
        cancelled = true;
      };
    }

    getThumbnailBlob(projectId).then((blob) => {
      if (cancelled) return;
      objectUrl = blob ? URL.createObjectURL(blob) : null;
      setUrl(objectUrl);
    });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [projectId, thumbnailAssetId]);

  return url;
}
